module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Importar Projeto'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Registro do projeto no SIEX",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "400"
    },
    model: {
      value: (_vm.pesquisa.registroSIEX),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "registroSIEX", $$v)
      },
      expression: "pesquisa.registroSIEX"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.pesquisarProjetoSIEX
    }
  }, [_vm._v("Pesquisar")])], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projetoSIEX && _vm.projetoSIEX.titulo),
      expression: "projetoSIEX && projetoSIEX.titulo"
    }]
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Título",
      "value": this.projetoSIEX.titulo
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Classificação Primária",
      "value": this.projetoSIEX.classificacaoPrimaria.descricao
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Classificação Secundária",
      "value": this.projetoSIEX.classificacaoSecundaria.descricao
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Data de início",
      "value": this.projetoSIEX.dataInicio || '-'
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Data de conclusão",
      "value": this.projetoSIEX.dataConclusao || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Tipo de público-alvo",
      "items": _vm.listaTipoPublico,
      "item-text": "descricao",
      "item-value": "id",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "return-object": "",
      "required": "",
      "autocomplete": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.projetoSIEX.tipoPublico),
      callback: function($$v) {
        _vm.$set(_vm.projetoSIEX, "tipoPublico", $$v)
      },
      expression: "projetoSIEX.tipoPublico"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Público-alvo estimado",
      "mask": "#########",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "20"
    },
    model: {
      value: (_vm.projetoSIEX.publicoAlvo),
      callback: function($$v) {
        _vm.$set(_vm.projetoSIEX, "publicoAlvo", $$v)
      },
      expression: "projetoSIEX.publicoAlvo"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [(_vm.projetoSIEX.classificacaoSecundaria && (_vm.projetoSIEX.classificacaoSecundaria.id === 39729 || _vm.projetoSIEX.classificacaoSecundaria.id === 44194 || _vm.projetoSIEX.classificacaoSecundaria.id === 44195)) ? _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Carga horária",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "20"
    },
    model: {
      value: (_vm.projetoSIEX.cargaHoraria),
      callback: function($$v) {
        _vm.$set(_vm.projetoSIEX, "cargaHoraria", $$v)
      },
      expression: "projetoSIEX.cargaHoraria"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Palavra-chave 1",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "400"
    },
    model: {
      value: (_vm.projetoSIEX.palavraChave01),
      callback: function($$v) {
        _vm.$set(_vm.projetoSIEX, "palavraChave01", $$v)
      },
      expression: "projetoSIEX.palavraChave01"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Palavra-chave 2",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "400"
    },
    model: {
      value: (_vm.projetoSIEX.palavraChave02),
      callback: function($$v) {
        _vm.$set(_vm.projetoSIEX, "palavraChave02", $$v)
      },
      expression: "projetoSIEX.palavraChave02"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Palavra-chave 3",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "400"
    },
    model: {
      value: (_vm.projetoSIEX.palavraChave03),
      callback: function($$v) {
        _vm.$set(_vm.projetoSIEX, "palavraChave03", $$v)
      },
      expression: "projetoSIEX.palavraChave03"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Palavra-chave 4",
      "max-height": "400"
    },
    model: {
      value: (_vm.projetoSIEX.palavraChave04),
      callback: function($$v) {
        _vm.$set(_vm.projetoSIEX, "palavraChave04", $$v)
      },
      expression: "projetoSIEX.palavraChave04"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', {
    attrs: {
      "label": "Resumo",
      "required": "",
      "rules": _vm.resumoRules,
      "rows": 3,
      "auto-grow": true,
      "multi-line": "",
      "counter": "1000"
    },
    model: {
      value: (_vm.projetoSIEX.resumo),
      callback: function($$v) {
        _vm.$set(_vm.projetoSIEX, "resumo", $$v)
      },
      expression: "projetoSIEX.resumo"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": _vm.importarProjetoSIEX
    }
  }, [_vm._v("Importar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7722d541","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/editar-projeto/importar-projeto.vue
// module id = 443
// module chunks = 0